

const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? '/backend-api'  // ✅ Relative path (uses same protocol as page)
    : 'http://localhost:3001');


console.log('📧 [emailApi] Environment:', process.env.NODE_ENV);
console.log('📧 [emailApi] Using API URL:', API_BASE_URL);


const emailApi = {
    /**
     * Get auth token from multiple sources
     */
    getAuthToken() {
        // Try multiple storage locations
        const token = localStorage.getItem('authToken') || 
                     localStorage.getItem('token') ||
                     sessionStorage.getItem('authToken') || 
                     sessionStorage.getItem('token') ||
                     null;
        
        console.log('🔑 [emailApi] Auth token found:', token ? 'Yes (length: ' + token.length + ')' : 'No');
        return token;
    },

    /**
     * Get headers with authentication
     */
    getHeaders() {
        const token = this.getAuthToken();
        const headers = {
            'Content-Type': 'application/json'
        };
        
        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }
        
        // Also try DHIS2 style authentication if available
        const dhis2Auth = this.getDhis2Auth();
        if (dhis2Auth) {
            headers['Authorization'] = dhis2Auth;
        }
        
        return headers;
    },

    /**
     * Get DHIS2 style authentication (Basic Auth)
     */
    getDhis2Auth() {
        // Check if DHIS2 auth is stored
        const auth = localStorage.getItem('dhis2Auth') || 
                    sessionStorage.getItem('dhis2Auth') ||
                    null;
        return auth;
    },

    /**
     * Send objective notification via backend
     */
    async sendObjectiveNotification(params) {
        try {
            const url = `${API_BASE_URL}/api/email/objective-notification`;
            const headers = this.getHeaders();
            
            console.log('📧 [emailApi] Sending request to:', url);
            console.log('📧 [emailApi] Headers:', {
                ...headers,
                Authorization: headers.Authorization ? 'Bearer [REDACTED]' : 'None'
            });

            const response = await fetch(url, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({
                    savedObjective: params.savedObjective,
                    parentObjectiveId: params.parentObjectiveId,
                    actionType: params.actionType || 'new',
                    currentUser: params.currentUser || null,
                    recipientOverride: params.recipientOverride || null,
                    fiscalYear: params.fiscalYear || null
                })
            });

            // Handle 401 specifically
            if (response.status === 401) {
                console.warn('⚠️ [emailApi] Authentication failed (401)');
                // Try to refresh token or redirect to login
                return {
                    success: false,
                    error: 'Authentication failed. Please log in again.',
                    status: 401
                };
            }

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log('✅ [emailApi] Response:', data);
            return data;

        } catch (error) {
            console.error('❌ [emailApi] Error:', error);
            throw error;
        }
    },

    /**
     * Send test email
     */
    async sendTestEmail(email) {
        try {
            const response = await fetch(`${API_BASE_URL}/api/email/test`, {
                method: 'POST',
                headers: this.getHeaders(),
                body: JSON.stringify({ email })
            });

            if (!response.ok) {
                const errorData = await response.json().catch(() => ({}));
                throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
            }

            return await response.json();
        } catch (error) {
            console.error('❌ [emailApi] Error sending test email:', error);
            throw error;
        }
    }
};

export default emailApi;